<template>
  <v-card>
    <v-card-text>
      <v-row dense>
        <v-col cols="12" sm="8">
          <p class="mb-1">
            <v-chip label class="mb-2">{{ solicitacao.id }}</v-chip>
            <span class="headline text--primary">
                {{ solicitacao.descricao }}
              </span>
          </p>
        </v-col>
        <v-col cols="12" sm="4"
               class="text-right"
               v-if="isNaoRespondida && isCotacaoAberta">
          <px-recusar-cotacao
            :loading="loadingRecusar"
            @change="onRecusar"/>
          <v-btn color="primary"
                 class="ml-2"
                 link :to="`/cotacao-conjunta/${idCotacao}/resposta`">
            Responder
          </v-btn>
        </v-col>
        <v-col cols="12" sm="4"
               class="text-right"
               v-if="isRespondida">
          <v-btn link :to="`/cotacao-conjunta/${idCotacao}/minha-resposta`" color="primary">
            Ver minha resposta
          </v-btn>
        </v-col>
      </v-row>
      <div class="text--primary">
        <v-row>
          <v-col cols="12" sm="4">
            <span class="caption font-weight-bold">Prazo de entrega</span>
            <div>
              {{ solicitacao.cotacaoConjunta.prazoEntrega | date | naoInformado }}
            </div>
          </v-col>
          <v-col cols="12" sm="4">
            <span class="caption font-weight-bold">Responder até</span>
            <div>
              {{ solicitacao.cotacaoConjunta.validade | date | naoInformado }}
            </div>
          </v-col>
        </v-row>
        <v-row v-if="municipiosText">
          <v-col cols="12">
            <span class="caption font-weight-bold">Municípios de entrega</span>
            <div>
              {{ municipiosText }}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <span class="caption font-weight-bold">Observação</span>
            <div>
              <px-show-large-text :large-text="solicitacao.cotacaoConjunta.observacao"/>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <px-responsaveis :responsaveis="solicitacao.fornecedoresReponsaveis"
                             custom-path="solicitacoes-respostas"
                             :id="solicitacao.id"
                             :id-company="solicitacao.fornecedor.id"
                             @update="onUpdate"/>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  SituacaoCotacao,
  SituacaoRespostaCotacaoProduto,
  SituacaoSolicitacaoResposta,
} from 'px-business-components';
import SolicitacaoService from '@/modules/cotacoes/detalhes/solicitacao-service';

const NAO_RECUSADAS = [SituacaoRespostaCotacaoProduto.keys.NAO_RESPONDIDA.key,
  SituacaoRespostaCotacaoProduto.keys.RESPONDIDA.key,
  SituacaoRespostaCotacaoProduto.keys.CANCELADA.key];


export default {
  props: {
    idCotacao: [String, Number],
    solicitacao: Object,
    municipios: Array,
  },
  data() {
    return {
      loadingRecusar: false,
    };
  },
  computed: {
    isNaoRespondida() {
      return this.solicitacao.situacaoSolicitacaoResposta
        === SituacaoSolicitacaoResposta.keys.NAO_RESPONDIDA.key;
    },
    isRespondida() {
      return this.solicitacao.situacaoSolicitacaoResposta
        === SituacaoSolicitacaoResposta.keys.RESPONDIDA.key;
    },
    isRecusada() {
      return !NAO_RECUSADAS.includes(this.solicitacao.situacaoSolicitacaoResposta);
    },
    isCotacaoAberta() {
      return this.solicitacao.cotacaoConjunta.situacao
        === SituacaoCotacao.keys.ABERTA.key;
    },
    municipiosText() {
      if (!this.municipios || !this.municipios.length) {
        return null;
      }
      return this.municipios.map((m) => `${m.nome} (${m.estado.sigla})`).join(', ');
    },
  },
  methods: {
    emitUpdate() {
      this.$emit('update');
    },
    onRecusar(option) {
      this.loadingRecusar = true;
      SolicitacaoService.recusar(this.idCotacao, {
        situacaoSolicitacaoResposta: option.key,
        outroMotivo: option.motivo,
      })
        .then(() => {
          this.$toast('Solicitação recusada', { color: 'success' });
          this.emitUpdate();
        })
        .finally(() => {
          this.loadingRecusar = false;
        });
    },
    onUpdate() {
      this.emitUpdate();
    },
  },
};
</script>
